import script from "./StatsRecentActivity.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatsRecentActivity.vue?vue&type=script&setup=true&lang=ts"

import "./StatsRecentActivity.vue?vue&type=style&index=0&id=4fe40c1c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fe40c1c"]])

export default __exports__